import './IconToggleButton.scss';
import Control from "../../Control";
import NP, {EventArgs} from "../../NP";
import Menu from "../Menu/Menu";

export default class IconToggleButton extends Control {


	_FontImage: string;
	_IsPressed: boolean;
	_Menu: Menu;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._FontImage = null;
		this._IsPressed = null;
		this._Menu = null;
		super._initFields(settings);
	}

	getFontImage()
	{
		return this._FontImage;
	}

	getMenu()
	{
		return this._Menu;
	}

	getIsPressed()
	{
		return this._IsPressed;
	}

	setIsPressed(value: boolean)
	{
		this._IsPressed = value;
		if (value)
			NP.addCssClass(this._root, 'mdc-ripple-upgraded--background-focused');
		else
			NP.removeCssClass(this._root, 'mdc-ripple-upgraded--background-focused');
	}

	_render()
	{
		this.np_render(`<span class="icon-toggle-button" role="button" aria-pressed="false"><span class="${this._FontImage}"></span></span>`);

		if (this._Menu && !(this._Menu instanceof Menu))
			this._Menu = new Menu(this._Menu);

		if (this._IsPressed != null)
			this.setIsPressed(this._IsPressed);
	}

	setEnabled(value: boolean, reInit?: boolean)
	{
		if (this._root)
		{
			if (!!value)
				NP.removeCssClass(this._root, 'icon-toggle-button--disabled');
			else
				NP.addCssClass(this._root, 'icon-toggle-button--disabled');
		}
		super.setEnabled(value, reInit);
	}

	_onClicked(sender: Control, args: EventArgs)
	{
		args.Event.preventDefault()
		args.Event.stopPropagation();

		if (this._Enabled)
		{
			if (this._IsPressed !== null)
				this.setIsPressed(!this._IsPressed);

			if (this._Menu)
			{
				this._Menu.setParent(this);
				NP.showDropPanel(this._Menu, this._root, NP.LTRB.Bottom);
			}

			return super._onClicked(this, args);
		}
	}

	setFontImage(value: string)
	{
		NP.removeCssClass(this._root.firstChild, this._FontImage);
		NP.addCssClass(this._root.firstChild, value);
		this._FontImage = value;
	}

	destroy()
	{
		this._Menu = null;
		super.destroy();
	}
}